import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { User, Users, ArrowRight } from "@phosphor-icons/react";

/**
 * Iter208.13 — Chooser del tipo di appuntamento.
 * Prima scelta prima di aprire il form di creazione:
 *  - `personal`  → blocca slot nel calendario del Pro (Quick Create, no partecipanti).
 *  - `shared`    → invita partecipanti via link pubblico (Create con voto/Doodle).
 *
 * Props:
 *  - open, onClose
 *  - onPick(kind: "personal" | "shared")
 */
export default function AppointmentTypeChooserModal({ open, onClose, onPick }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent className="max-w-lg" data-testid="appointment-type-chooser">
        <DialogHeader>
          <DialogTitle>Nuovo appuntamento</DialogTitle>
          <p className="text-sm text-slate-500 mt-1">
            Scegli il tipo di appuntamento da creare
          </p>
        </DialogHeader>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
          <ChoiceCard
            testId="chooser-personal"
            title="Personale"
            icon={<User size={24} weight="bold" />}
            iconClass="text-purple-700 bg-purple-100"
            desc="Blocca lo slot nel tuo calendario. Non condiviso con partecipanti esterni."
            onClick={() => onPick?.("personal")}
          />
          <ChoiceCard
            testId="chooser-shared"
            title="Condiviso"
            icon={<Users size={24} weight="bold" />}
            iconClass="text-emerald-700 bg-emerald-100"
            desc="Proponi più date, invita partecipanti via link pubblico e raccogli le disponibilità."
            onClick={() => onPick?.("shared")}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

function ChoiceCard({ testId, title, desc, icon, iconClass, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className="group text-left border rounded-lg p-4 bg-white hover:border-purple-400 hover:shadow-md transition-all focus:outline-none focus:ring-2 focus:ring-purple-400"
    >
      <div className={"inline-flex items-center justify-center w-10 h-10 rounded-full mb-2 " + iconClass}>
        {icon}
      </div>
      <div className="flex items-center justify-between">
        <div className="font-semibold text-slate-900">{title}</div>
        <ArrowRight size={16} className="text-slate-400 group-hover:text-purple-600 transition-colors" />
      </div>
      <div className="text-xs text-slate-600 mt-1 leading-relaxed">{desc}</div>
    </button>
  );
}
